import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { SftpImportConfigurationWorkflow, ImportType } from '../../../store/Models/Api/SftpImportModels';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { FileStructureSection } from '../sections/FileStructureSection';
import { AdvancedOptionsSection } from '../sections/AdvancedOptionsSection';

interface MultipleBomDefaultHandlingPanelLocalProps {
    config: SftpImportConfigurationWorkflow;
}

type MultipleBomDefaultHandlingPanelProps = MultipleBomDefaultHandlingPanelLocalProps & ToxnotComponentProperties;

class MultipleBomDefaultHandlingPanelComponent extends ToxnotComponent<MultipleBomDefaultHandlingPanelProps> {
    render() {
        const { config } = this.props;
        const isSupplierImport = config.importType === ImportType.Suppliers;

        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">{this.localizeString("Default Handling")}</h3>
                </div>
                <div className="panel-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="start-subcontent-heading">{this.localizeString("File Structure")}</div>
                            <FileStructureSection
                                configData={config}
                                onConfigChange={() => {}} // Read-only mode
                                readOnly={true}
                            />
                        </div>
                        {!isSupplierImport && (
                            <div className="col-md-6">
                                <AdvancedOptionsSection
                                    configData={config}
                                    onConfigChange={() => {}} // Read-only mode
                                    readOnly={true}
                                    collapsible={false}
                                    defaultExpanded={true}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export const MultipleBomDefaultHandlingPanel = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(MultipleBomDefaultHandlingPanelComponent);
